// MG Swatch Sets export: FAQs

// ✅ ONCE-ONLY LINES (copy once per file/snippet — skip if you already have these):
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};

// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-WNK08"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_3455f523-6d2f-4388-b6dc-29ab322fbc65.png?v=1767716042&width=400",
          "product_url": "/products/woodnfinish_white-wash_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_white-wash_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK-wBox.png?v=1778164807&width=400",
          "product_url": "/products/woodnfinish_white-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK-wBox_ebb44b3d-f5d2-4c46-86dd-b07a3b8ff86c.png?v=1778174024&width=400",
          "product_url": "/products/woodnfinish_french-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_french-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-wBox.png?v=1777490925&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-wBox.png?v=1778170399&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH-wBox.png?v=1778161783&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-wBox.png?v=1778166988&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL-wBox.png?v=1777567857&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_9b1b8a88-0e2f-48a4-9146-e2d538d96d22.png?v=1767714626&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_f8fd0e0f-f368-4cff-a9aa-ac0793fcf2f6.png?v=1767638634&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Fireplace-Mantle_969a4e88-44aa-4b70-b0e6-18021778c101.jpg?v=1767634092&width=400",
          "product_url": "/products/woodnfinish_cedar_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_cedar_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Tabletop_ef43e47d-c671-467c-9e05-9a5c76cd9f13.jpg?v=1767971913&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_java_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_java_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_old-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_old-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Front-Door_8259f809-cb75-4b6a-9607-1b343a395fc6.jpg?v=1767643352&width=400",
          "product_url": "/products/woodnfinish_pecan_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_pecan_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_charcoal_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_charcoal_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets_3ce201a1-1f22-4110-b8b1-25703adbbbad.jpg?v=1767633249&width=400",
          "product_url": "/products/woodnfinish_classic-black_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_classic-black_s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK08-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_550cedd8-8649-48c0-a8aa-11f8d03b6142.png?v=1767716145&width=400",
          "product_url": "/products/woodnfinish_white-wash_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-wash_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK-TPLQM-BoxBNI.png?v=1767715373&width=400",
          "product_url": "/products/woodnfinish_white-oak_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK-TPLQM-wBox_6918e1da-e61e-4246-bbd6-cf952d9e83d9.png?v=1777388947&width=400",
          "product_url": "/products/woodnfinish_french-oak_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_french-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-TPLQM-wBox_2ccfdb31-92be-422c-ae71-7784af2b803c.png?v=1777490992&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-TPLQM-BoxBNI.png?v=1767636121&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH-TPLQM-BoxBNI.png?v=1767646713&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-TPLQM-BoxBNI.png?v=1767712520&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL-TPLQM-wBox.png?v=1777567975&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_9e46defc-f882-4aed-b238-48977b343f9c.png?v=1767714721&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DRIW-TPLQS-wBox.png?v=1776195857&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_3cf12201-8630-4852-8b1c-ddfb26fee73f.png?v=1767634184&width=400",
          "product_url": "/products/woodnfinish_cedar_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_cedar_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Fireplace-Mantle_24d568b9-ee22-493e-8110-7d5d36472176.jpg?v=1767972087&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-TPLQM-BoxBNI.png?v=1767714077&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA-TPLQS-BoxBNI.png?v=1767641433&width=400",
          "product_url": "/products/woodnfinish_java_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_java_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-OOAK-TPLQS-BoxBNI.png?v=1767642566&width=400",
          "product_url": "/products/woodnfinish_old-oak_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_old-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Swatch-Rustic-Small_8e11ae6f-fa5f-4694-8da6-eac417a4dcc5.jpg?v=1767643461&width=400",
          "product_url": "/products/woodnfinish_pecan_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pecan_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHAR-TPLQG-BoxBNI.png?v=1767635060&width=400",
          "product_url": "/products/woodnfinish_charcoal_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_charcoal_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CBLK-TPLQG-BoxBNI.png?v=1767633406&width=400",
          "product_url": "/products/woodnfinish_classic-black_s_tripletique",
          "cta": {
            "href": "/products/woodnfinish_classic-black_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK08-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/b99946a43b1440ffb14e20ae76340058.thumbnail.0000000000.jpg?v=1680285466&width=400",
          "product_url": "/products/woodnfinish_white-wash_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-wash_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK-PLTQM-wBox.png?v=1778164872&width=400",
          "product_url": "/products/woodnfinish_white-oak_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK-PLTQM-wBox_1045f5c9-1a67-41fb-835a-f5b59f68cf5e.png?v=1778174063&width=400",
          "product_url": "/products/woodnfinish_french-oak_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_french-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-PLTQM-wBox_4b56acea-8f1e-4a1f-a5c5-01248f414682.png?v=1777491092&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-PLTQM-wBox.png?v=1778172838&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH-PLTQM-wBox.png?v=1778161864&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-PLTQM-wBox_63c5235b-1f4d-457c-8f00-2069245d0be5.png?v=1778167787&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL-PLTQM-wBox.png?v=1777568088&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WETH-PLTQM-wBox.png?v=1778174893&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_d1950b8c-4b08-40bc-9264-4850663b8970.png?v=1767638973&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CEDR-PLTQM-wBox.png?v=1778176737&width=400",
          "product_url": "/products/woodnfinish_cedar_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_cedar_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "center",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-PLTQM-wBox.png?v=1778176527&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s_polytique-it",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s_polytique-it",
            "text": "Shop"
          },
          "product_id": 6830501101702,
          "available": true
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA-PLTQM-wBox.png?v=1778176287&width=400",
          "product_url": "/products/woodnfinish_java_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_java_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-OOAK-PLTQM-wBox.png?v=1778176919&width=400",
          "product_url": "/products/woodnfinish_old-oak_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_old-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/hqdefault_7bb54d72-c361-4b85-ba90-d129e0a70770.jpg?v=1675104825&width=400",
          "product_url": "/products/woodnfinish_pecan_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pecan_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHAR-PLTQM-BoxBNI_6ecf45cb-db63-463f-84a6-ee90b15d1e75.png?v=1778175079&width=400",
          "product_url": "/products/woodnfinish_charcoal_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_charcoal_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CBLK-PLTQM-wBox.png?v=1778175750&width=400",
          "product_url": "/products/woodnfinish_classic-black_s_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_classic-black_s_polytique-it",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK16"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/78b0a08120e04baf9b89cf8181bd1c99.thumbnail.0000000000.jpg?v=1680284952&width=400",
          "product_url": "/products/woodnfinish_white-wash_m",
          "cta": {
            "href": "/products/woodnfinish_white-wash_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WOAK-wBox.png?v=1778164953&width=400",
          "product_url": "/products/woodnfinish_white-oak_m",
          "cta": {
            "href": "/products/woodnfinish_white-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-wBox.png?v=1777388184&width=400",
          "product_url": "/products/woodnfinish_french-oak_m",
          "cta": {
            "href": "/products/woodnfinish_french-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-wBox.png?v=1777491197&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DOAK-Products-Retail.png?v=1776103978&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-SBCH-wBox.png?v=1778162023&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-POAK-Products-Retail.png?v=1776103821&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/barnwoodinspo.png?v=1776103920&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BWAL-wBox.png?v=1777568227&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_88dcd71a-5eaa-4311-b245-c51cda58d575.jpg?v=1776104243&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/hqdefault_fc6bcce8-333b-4cec-8d08-371d082ecc87.jpg?v=1675095838&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Front-Door_cd25b8ed-ce28-4633-86b3-4bad308e05b6.jpg?v=1776104532&width=400",
          "product_url": "/products/woodnfinish_cedar_m",
          "cta": {
            "href": "/products/woodnfinish_cedar_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_67544062-07aa-43e1-8595-8165dd0a728d.jpg?v=1776104334&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-Products-Retail.png?v=1776104485&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Kitchen-Counterop_e6efe888-4619-47f2-b1d3-0ac0ed2d5887.jpg?v=1776104436&width=400",
          "product_url": "/products/woodnfinish_java_m",
          "cta": {
            "href": "/products/woodnfinish_java_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Swatch-Rustic-Small_7fed8ed0-ec22-4500-b992-75298f134b5c.jpg?v=1776104586&width=400",
          "product_url": "/products/woodnfinish_old-oak_m",
          "cta": {
            "href": "/products/woodnfinish_old-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Front-Door_d479a36e-23bc-4474-90df-34b1c5985a9b.jpg?v=1776104630&width=400",
          "product_url": "/products/woodnfinish_pecan_m",
          "cta": {
            "href": "/products/woodnfinish_pecan_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Tabletop_ea74b414-a9a3-44de-92cb-fa0401317663.jpg?v=1776104288&width=400",
          "product_url": "/products/woodnfinish_charcoal_m",
          "cta": {
            "href": "/products/woodnfinish_charcoal_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door_1ecaa679-af47-4f95-8d43-d3a0c6f75029.jpg?v=1776104386&width=400",
          "product_url": "/products/woodnfinish_classic-black_m",
          "cta": {
            "href": "/products/woodnfinish_classic-black_m",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK16-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_white-wash_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WOAK-TPLQM-wBox.png?v=1778165081&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-TPLQM-wBox.png?v=1777389246&width=400",
          "product_url": "/products/woodnfinish_french-oak_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-TPLQM-wBox.png?v=1777491270&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DOAK-TPLQM-BoxBNI.png?v=1767636667&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-SBCH-TPLQM-wBox.png?v=1778162304&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-POAK-TPLQM-BoxBNI.png?v=1767713007&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BWAL-TPLQM-wBox.png?v=1777568376&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Kit-_Grained_c6c03c21-70a9-47b4-80bf-aab8e32862bf.jpg?v=1767714943&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_cedar_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Tabletop_bd0a0208-8d7e-4366-9e07-47800399db5e.jpg?v=1767971650&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_java_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_old-oak_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Swatch-Rustic-Small_ff963495-a3ce-433a-86d3-ce20eeab3eb9.jpg?v=1767645173&width=400",
          "product_url": "/products/woodnfinish_pecan_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_charcoal_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CBLK-TPLQS-BoxBNI.png?v=1767633902&width=400",
          "product_url": "/products/woodnfinish_classic-black_m_tripletique",
          "cta": {
            "href": "/products/woodnfinish_classic-black_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK16-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_169f9f45-0f1d-4632-83ae-863a06abc23c.png?v=1767716464&width=400",
          "product_url": "/products/woodnfinish_white-wash_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-wash_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WOAK-PLTQM-wBox.png?v=1778165198&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-PLTQM-wBox.png?v=1777390444&width=400",
          "product_url": "/products/woodnfinish_french-oak_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_french-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-PLTQM-wBox.png?v=1777491391&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DOAK-PLTQM-BoxBNI.png?v=1767636782&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-SBCH-PLTQM-wBox.png?v=1778162202&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-POAK-PLTQM-BoxBNI.png?v=1767713137&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-Rusic_ffe50d2c-595b-4daf-a2d1-d65671b63d71.jpg?v=1767633094&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BWAL-PLTQM-wBox.png?v=1777568506&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_ac3470eb-3e13-4218-8887-a8e70ad88b67.jpg?v=1767715121&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_ba741a7a-99aa-4257-ad73-6b26afeb21c6.png?v=1767634759&width=400",
          "product_url": "/products/woodnfinish_cedar_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_cedar_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK16-CHRY-PLTQ-back_c92a5e10-b0e1-4679-8310-15d563d9a07e.png?v=1767971826&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-PLTQM-BoxBNI.png?v=1767714460&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-JAVA-PLTQG-BoxBNI.png?v=1767641940&width=400",
          "product_url": "/products/woodnfinish_java_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_java_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-OOAK-PLTQG-BoxBNI.png?v=1767643089&width=400",
          "product_url": "/products/woodnfinish_old-oak_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_old-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_24b531b9-d8a1-407d-b04a-4a3f26f1ba90.png?v=1767645352&width=400",
          "product_url": "/products/woodnfinish_pecan_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pecan_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CHAR-PLTQG-BoxBNI.png?v=1767635794&width=400",
          "product_url": "/products/woodnfinish_charcoal_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_charcoal_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PLTQ-Matte-CBLK-Table_f6a30f6e-f343-4f3d-87e2-c8ba4482b7c8.png?v=1776284975&width=400",
          "product_url": "/products/woodnfinish_classic-black_m_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_classic-black_m_polytique-it",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK32"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Decking-Rustic_6efa6d79-22b2-44ad-86b1-af2e02279ad5.jpg?v=1776267825&width=400",
          "product_url": "/products/woodnfinish_white-wash_l",
          "cta": {
            "href": "/products/woodnfinish_white-wash_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-wBox.png?v=1773241500&width=400",
          "product_url": "/products/woodnfinish_white-oak_l",
          "cta": {
            "href": "/products/woodnfinish_white-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-wBox_399c12d9-a494-40a1-bdbf-a9ce538352de.png?v=1777388403&width=400",
          "product_url": "/products/woodnfinish_french-oak_l",
          "cta": {
            "href": "/products/woodnfinish_french-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-wBox.png?v=1777491478&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-wBox.png?v=1773242884&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-wBox_f09c5da2-1c84-43c6-978e-eb32f24079b0.png?v=1778162487&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-wBox.png?v=1773242057&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-table.png?v=1773242530&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-wBox.png?v=1773243420&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-03_a859e3a9-9010-44e1-bb07-4d88f8d1200b.png?v=1773244903&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CedarKit-FB_666ae01c-d4a3-4d32-ab4f-743212017b09.jpg?v=1773247875&width=400",
          "product_url": "/products/woodnfinish_cedar_l",
          "cta": {
            "href": "/products/woodnfinish_cedar_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-table.png?v=1773245487&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-wBox.png?v=1773247636&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-_Grained_d5d5f143-bf4a-448e-8a54-ed7038b39098.jpg?v=1773247167&width=400",
          "product_url": "/products/woodnfinish_java_l",
          "cta": {
            "href": "/products/woodnfinish_java_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_b73e95eb-b7f1-48a8-9fc3-c3e6b08437c1.jpg?v=1773248162&width=400",
          "product_url": "/products/woodnfinish_old-oak_l",
          "cta": {
            "href": "/products/woodnfinish_old-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_8a41f92b-127a-4c35-8ee1-aaa02ae17ad3.jpg?v=1773248419&width=400",
          "product_url": "/products/woodnfinish_pecan_l",
          "cta": {
            "href": "/products/woodnfinish_pecan_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_fee38ec6-b3fc-4ae5-a474-9cb07db08cb4.jpg?v=1773245188&width=400",
          "product_url": "/products/woodnfinish_charcoal_l",
          "cta": {
            "href": "/products/woodnfinish_charcoal_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-_Grained_8ba0d109-c4b9-45f6-83e7-7fb40fbd8904.jpg?v=1773245940&width=400",
          "product_url": "/products/woodnfinish_classic-black_l",
          "cta": {
            "href": "/products/woodnfinish_classic-black_l",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK32-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_white-wash_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-wash_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-TPLQM-wBox.png?v=1773241580&width=400",
          "product_url": "/products/woodnfinish_white-oak_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-TPLQM-wBox_d040094a-7524-4f29-aa36-e1602176d58d.png?v=1777389427&width=400",
          "product_url": "/products/woodnfinish_french-oak_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_french-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-TPLQM-wBox.png?v=1777491541&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-TPLQM-wBox.png?v=1773243117&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-TPLQM-wBox_8c359ed6-2b39-4287-a2f0-1bc497cbacb0.png?v=1778162742&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-TPLQM-wBox.png?v=1773242141&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-TPLQM-wBox.png?v=1773243536&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-TPLQG-wBox.png?v=1776195995&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Tabletop-_Grained_f1f5a83c-f68b-448e-822c-3e855ab318a4.jpg?v=1773247956&width=400",
          "product_url": "/products/woodnfinish_cedar_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_cedar_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Decking-_Grained_d4905a0d-73bf-4c1d-8dfc-18a85ec2dc76.jpg?v=1773245580&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-TPLQM-wBox.png?v=1773247731&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_47802279-c9d4-4597-887f-440ee3d45cd6.jpg?v=1765829725&width=400",
          "product_url": "/products/woodnfinish_java_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_java_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_2e69c866-f8d6-406d-b541-5274f2977b5d.jpg?v=1773248258&width=400",
          "product_url": "/products/woodnfinish_old-oak_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_old-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_edf7640d-599a-489a-8dcd-ea86480c7ec4.jpg?v=1773248493&width=400",
          "product_url": "/products/woodnfinish_pecan_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pecan_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_3aba3503-aabb-46cc-9dda-50dee6c9b0dd.jpg?v=1773245292&width=400",
          "product_url": "/products/woodnfinish_charcoal_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Tabletop-_Grained_c4c5ab4d-b086-4167-bb56-f2020ab93c20.jpg?v=1773246110&width=400",
          "product_url": "/products/woodnfinish_classic-black_l_tripletique",
          "cta": {
            "href": "/products/woodnfinish_classic-black_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK32-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/b1241a1ed60e4fd7a772af7094917ecf.thumbnail.0000000000.jpg?v=1680284823&width=400",
          "product_url": "/products/woodnfinish_white-wash_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-wash_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-PLTQM-wBox.png?v=1773241654&width=400",
          "product_url": "/products/woodnfinish_white-oak_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-PLTQM-wBox_8e2953b0-c8a7-4ef8-b2a3-5a75833f33ea.png?v=1777390553&width=400",
          "product_url": "/products/woodnfinish_french-oak_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_french-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-PLTQM-wBox.png?v=1777491668&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-PLTQM-wBox.png?v=1773243322&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-PLTQM-wBox_f2e28071-a2af-400c-b6f7-8060e48d69ca.png?v=1778162628&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-PLTQM-wBox.png?v=1773242245&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-PLTQM-wBox.png?v=1773243646&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-14_87d74429-8a6d-4a28-9355-82e28cd20b40.png?v=1773245093&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_40e0a2f2-4e22-4403-b192-543f98884394.png?v=1773244808&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_40efcaf4-40b8-40db-923b-1ffccd8e4156.jpg?v=1773248051&width=400",
          "product_url": "/products/woodnfinish_cedar_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_cedar_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Decking-_Grained_1d761b7b-4fbc-4cc2-bfb6-36695f883bc8.jpg?v=1773245653&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-PLTQM-wBox.png?v=1773247794&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_53e0b103-e94e-483b-b4f5-defa08dde12d.jpg?v=1773247547&width=400",
          "product_url": "/products/woodnfinish_java_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_java_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_2702e969-e050-4a64-af39-b94a7b12b157.jpg?v=1773248339&width=400",
          "product_url": "/products/woodnfinish_old-oak_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_old-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Kit-_Grained_af14832c-5128-40fd-ae33-9e91273e8abd.jpg?v=1773248585&width=400",
          "product_url": "/products/woodnfinish_pecan_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pecan_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_9972eddc-3d0b-4623-ab98-ffec93adae0b.jpg?v=1773245381&width=400",
          "product_url": "/products/woodnfinish_charcoal_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Tabletop-_Grained_5bd6aa5c-9fa9-48fa-b094-44c2735ea3e3.jpg?v=1773246202&width=400",
          "product_url": "/products/woodnfinish_classic-black_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_classic-black_l_polytique-it",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK128"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/6161161ee7304e47a8615640eae53e54.thumbnail.0000000000.jpg?v=1680284455&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl",
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-wBox.png?v=1773252919&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl",
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-wBox_21ee1bbb-b85d-423d-907a-f86ba3ebb838.png?v=1777388555&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl",
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-wBox.png?v=1777491753&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-wBox.png?v=1773253801&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-wBox_eb0c83dd-87ee-4637-a0de-88378589a78e.png?v=1778162872&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-wBox.png?v=1773253169&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-wBox.png?v=1773253456&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-wBox.png?v=1773254161&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WeatheredWoodKit-FB.jpg?v=1773256414&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-03_6e296d13-6b0b-4a04-8ca7-b08eeef004e8.png?v=1773256101&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets-_Grained_148d2f97-592d-486b-801f-126857632b14.jpg?v=1773260038&width=400",
          "product_url": "/products/woodnfinish_cedar_xl",
          "cta": {
            "href": "/products/woodnfinish_cedar_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-table.png?v=1773257031&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA-wBox_0dd154d6-9ca0-4f39-868e-b889bccc3e7a.png?v=1773259914&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_28c5d42d-b7a9-4288-bfaa-fd4105d92062.jpg?v=1773259137&width=400",
          "product_url": "/products/woodnfinish_java_xl",
          "cta": {
            "href": "/products/woodnfinish_java_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_40a13a94-1199-4d0b-9dd2-60bf59b0cf7a.jpg?v=1773260374&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl",
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_16d9055f-1d4d-4d71-9884-dba4abbaa2ef.jpg?v=1773260621&width=400",
          "product_url": "/products/woodnfinish_pecan_xl",
          "cta": {
            "href": "/products/woodnfinish_pecan_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-wBox.png?v=1773256713&width=400",
          "product_url": "/products/woodnfinish_charcoal_xl",
          "cta": {
            "href": "/products/woodnfinish_charcoal_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_07fc878a-88cd-43d5-956d-3a957ae126bd.jpg?v=1773258829&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl",
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK128-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/6cab7bf4fd3144a3b9816054a75c13d7.thumbnail.0000000000.jpg?v=1680284572&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-TPLQM-wBox.png?v=1773253001&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-TPLQM-wBox.png?v=1777389998&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-TPLQM-wBox.png?v=1777491853&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-TPLQM-wBox.png?v=1773253885&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-TPLQM-wBox_3208064d-f3b7-444b-9161-b19e89225465.png?v=1778162967&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-TPLQM-wBox.png?v=1773253296&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-TPLQM-wBox.png?v=1773253553&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-TPLQM-wBox.png?v=1773254302&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-Rustic_63deca17-55d8-4fe5-912a-6e83b25f1dbc.jpg?v=1776267968&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Instructions-Front_ee8de7f8-7284-4bd7-a403-4228128acebe.png?v=1775057671&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-_Grained_30ff82e3-cdbb-47fc-be8e-0153490450fd.jpg?v=1773260122&width=400",
          "product_url": "/products/woodnfinish_cedar_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_cedar_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-TPLQ-Matte-table.png?v=1773258397&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Box-WoodnFinishKit128-_Grained_cb0d9f18-c15e-4441-baee-03d51e2088aa.jpg?v=1707617822&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Grained_b1f4dc49-9dcb-4dae-8a5f-aa49a3521288.jpg?v=1773259236&width=400",
          "product_url": "/products/woodnfinish_java_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_java_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatches-OneKit3Finishes_a6cf15e5-226d-4313-b576-d2e323792e6b.jpg?v=1773260457&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_4cdce9e3-6585-4ef8-bc8d-3f2caf7e8618.jpg?v=1773260701&width=400",
          "product_url": "/products/woodnfinish_pecan_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_pecan_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-TPLQM-wBox.png?v=1773256858&width=400",
          "product_url": "/products/woodnfinish_charcoal_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_7f20602c-c093-48c2-824a-6ac48bc6ec8f.jpg?v=1773258967&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK128-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_35ca7edb-3211-4254-a307-4ee667efcf8c.png?v=1776267825&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-PLTQM-wBox.png?v=1773253092&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-PLTQM-wBox_4876739d-8994-4774-860d-a9e6b0c4925c.png?v=1777390703&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-WNK-MWAL-small.jpg?v=1779541093",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-TPLQM-wBox.png?v=1777491853&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl_tripletique",
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-PLTQM-wBox.png?v=1773254055&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-PLTQM-wBox_95ff3ba9-c447-49aa-bfeb-c0ed4cb1e4c5.png?v=1778163146&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-PLTQM-wBox.png?v=1773253393&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-PLTQ-Matte-table.png?v=1776266727&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-PLTQM-wBox.png?v=1773254477&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-12_56903c40-7cf1-49ee-afca-174d4a65ac3f.png?v=1776267968&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Instructions-Front_4ef213f0-fea6-479c-8ec4-29176a79c6c1.png?v=1776267934&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-12_65868c6f-501b-4097-82fd-024eaa285fa5.png?v=1776268798&width=400",
          "product_url": "/products/woodnfinish_cedar_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_cedar_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_8273b4db-616e-4f65-abc5-b6dc8a29ef43.jpg?v=1776268389&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Box-WoodnFinishKit128-_Grained_e4b717d0-ced4-41cd-bd44-7dd264201a45.jpg?v=1707617673&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_1395d820-7e40-4e1d-bff5-edf7f62c599a.jpg?v=1776268762&width=400",
          "product_url": "/products/woodnfinish_java_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_java_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-_Grained_a172f099-3d14-4415-a26b-fb0f7eb79ed5.jpg?v=1776268900&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_d7275e7e-7e31-436c-b750-fb5d58df30dd.jpg?v=1776268968&width=400",
          "product_url": "/products/woodnfinish_pecan_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_pecan_xl_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_9972eddc-3d0b-4623-ab98-ffec93adae0b.jpg?v=1773245381&width=400",
          "product_url": "/products/woodnfinish_charcoal_l_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-_Grained_930808b0-6000-4118-9c9d-35d792950e35.jpg?v=1776268702&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl_polytique-it",
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-RMGY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Red Mahogany Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA_fa0fd4ce-dedf-4b52-8ed2-a7cf9248228a.png?v=1776109760&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29453941178502,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA_fa0fd4ce-dedf-4b52-8ed2-a7cf9248228a.png?v=1776109760&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s",
          "product_id": 6829867794566,
          "price": "$69.99",
          "price_num": 69.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_a2c27512-ba99-472e-b6f9-c7cffa3268b9.png?v=1776109798&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29453941670022,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_a2c27512-ba99-472e-b6f9-c7cffa3268b9.png?v=1776109798&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m",
          "product_id": 6829925924998,
          "price": "$109.99",
          "price_num": 109.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA_0ca76202-a99f-449c-8c53-cb615ffa539b.png?v=1776109834&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29453942194310,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA_0ca76202-a99f-449c-8c53-cb615ffa539b.png?v=1776109834&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l",
          "product_id": 6829916520582,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA_c8418440-5392-4ed4-8d3e-ebff4d17b40b.png?v=1776109862&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29630806818950,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-wBox.png?v=1778702029&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl",
          "product_id": 6829890633862,
          "price": "$549.99",
          "price_num": 549.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-RMGY-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Red Mahogany Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-TPLQS.png?v=1776178421&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29457591206022,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-TPLQS.png?v=1776178421&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s_tripletique",
          "product_id": 6829973241990,
          "price": "$109.99",
          "price_num": 109.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-TPLQ-Matte-RMGY.png?v=1776182941&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29457715724422,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-TPLQ-Matte-RMGY.png?v=1776182941&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m_tripletique",
          "product_id": 6830021345414,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-TPLQ-Matte.png?v=1776185851&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29457856004230,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-TPLQ-Matte.png?v=1776185851&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l_tripletique",
          "product_id": 6830073249926,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-TPLQ-Matte.png?v=1778702181&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29630817206406,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-TPLQ-Matte.png?v=1778702181&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl_tripletique",
          "product_id": 6830103789702,
          "price": "$799.99",
          "price_num": 799.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-RMGY-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Red Mahogany Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-PLTQM.png?v=1776258341&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29601392951430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-RMGY-PLTQM-wBox.png?v=1778176527&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_s_polytique-it",
          "product_id": 6830501101702,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-PLTQ-Gloss-RMGY.png?v=1776263384&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29462701572230,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-RMGY-PLTQ-Gloss-RMGY.png?v=1776263384&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_m_polytique-it",
          "product_id": 6830522597510,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-PLTQ-Matte.png?v=1776285721&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29464527503494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-PLTQ-Matte.png?v=1776285721&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_l_polytique-it",
          "product_id": 6830538129542,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-PLTQ-Matte.png?v=1778702293&width=400",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29630824218758,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-PLTQ-Matte.png?v=1778702293&width=400",
          "product_url": "/products/woodnfinish_red-mahogany_xl_polytique-it",
          "product_id": 6830550810758,
          "price": "$799.99",
          "price_num": 799.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_red-mahogany_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Help-WNK-Sizes"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 2,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<p>More Help on Sizes</p>",
      "subheading": "",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_FXtPR9-0",
      "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<div style=\"text-align: center;\"><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Approximate surface coverage with a Small Retique It kit\" alt=\"Retique It Small Wood Finish Kit coverage guide\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Surface area covered by a Medium Retique It wood finish kit\" alt=\"Medium Retique It Wood Finish Kit coverage\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Estimated coverage area for Large Retique It kit\" alt=\"Large Retique It Kit project coverage estimate\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"How much surface area a 4x Large Retique It kit can cover\" alt=\"Coverage for 4x Large Retique It wood finish kit\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" style=\"margin-bottom: 20px; float: none;\"><br><img title=\"How to measure square footage for Retique It DIY refinishing projects\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a></div>",
      "custom_width_desktop_percent": "90",
      "custom_width_mobile_percent": "95",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Help-WNK-TPLQ-Sizes"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 2,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<p>More Help on Sizes</p>",
      "subheading": "",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_FXtPR9-0",
      "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<div style=\"text-align: center;\"><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Approximate surface coverage with a Small Retique It kit\" alt=\"Retique It Small Wood Finish Kit coverage guide\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Surface area covered by a Medium Retique It wood finish kit\" alt=\"Medium Retique It Wood Finish Kit coverage\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Estimated coverage area for Large Retique It kit\" alt=\"Large Retique It Kit project coverage estimate\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"How much surface area a 4x Large Retique It kit can cover\" alt=\"Coverage for 4x Large Retique It wood finish kit\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" style=\"margin-bottom: 20px; float: none;\"><br><img title=\"How to measure square footage for Retique It DIY refinishing projects\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a></div>",
      "custom_width_desktop_percent": "90",
      "custom_width_mobile_percent": "95",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Help-WNK-PLTQ-Sizes"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 2,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<p>More Help on Sizes</p>",
      "subheading": "",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_FXtPR9-0",
      "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<div style=\"text-align: center;\"><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Approximate surface coverage with a Small Retique It kit\" alt=\"Retique It Small Wood Finish Kit coverage guide\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Surface area covered by a Medium Retique It wood finish kit\" alt=\"Medium Retique It Wood Finish Kit coverage\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Estimated coverage area for Large Retique It kit\" alt=\"Large Retique It Kit project coverage estimate\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"How much surface area a 4x Large Retique It kit can cover\" alt=\"Coverage for 4x Large Retique It wood finish kit\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" style=\"margin-bottom: 20px; float: none;\"><br><img title=\"How to measure square footage for Retique It DIY refinishing projects\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a></div>",
      "custom_width_desktop_percent": "90",
      "custom_width_mobile_percent": "95",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-SBCH"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 138,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e1dabb",
      "gradient_angle": 138,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Sun Bleached Size Options</h3>",
      "subheading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH.png?width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s",
          "product_id": 7195719008390,
          "product_variant_id": null,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D.png?v=1776107184&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m",
          "product_id": 7195720417414,
          "product_variant_id": null,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH.png?v=1776107229&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l",
          "product_id": 7195720024198,
          "product_variant_id": null,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH_0073eaa6-f39d-4cf9-bab2-482416377a98.png?v=1776107303&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl",
          "product_id": 7195719499910,
          "product_variant_id": null,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-SBCH-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Sun Bleached Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH-TPLQM.png?v=1776177271&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s_tripletique",
          "product_id": 7195720712326,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-SBCH-TPLQ-Satin-SBCH.png?v=1776181456&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m_tripletique",
          "product_id": 7195720974470,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-TPLQ-Matte.png?v=1776183542&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l_tripletique",
          "product_id": 7195721269382,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-TPLQ-Matte_5d47f54b-ff98-4a13-a2d6-114960cbe692.png?v=1776186093&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl_tripletique",
          "product_id": 7195721564294,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-SBCH-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Sun Bleached Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH-PLTQM.png?v=1776256541&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s_polytique-it",
          "product_id": 7195721891974,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-SBCH-PLTQ-Matte-SBCH.png?v=1776258813&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m_polytique-it",
          "product_id": 7195722186886,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-PLTQ-Matte.png?v=1776263794&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l_polytique-it",
          "product_id": 7195722580102,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-PLTQ-Matte.png?v=1776279137&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl_polytique-it",
          "product_id": 7195722907782,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-WOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>White Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK.png?v=1776107635&width=400",
          "product_url": "/products/woodnfinish_white-oak_s",
          "product_id": 6982958874758,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_9809b8c2-2f9d-4bd9-9ead-803e765b47d6.png?v=1776107644&width=400",
          "product_url": "/products/woodnfinish_white-oak_m",
          "product_id": 6982959104134,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK.png?v=1776107669&width=400",
          "product_url": "/products/woodnfinish_white-oak_l",
          "product_id": 6982959038598,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK_1f670b26-be0d-4534-b94f-07427ce3cfd6.png?v=1776107777&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl",
          "product_id": 6982958973062,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>White Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK-TPLQS.png?v=1776177364&width=400",
          "product_url": "/products/woodnfinish_white-oak_s_tripletique",
          "product_id": 6982959169670,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WOAK-TPLQ-Satin-WOAK.png?v=1776181533&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_tripletique",
          "product_id": 6982959235206,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-TPLQ-Satin.png?v=1776183606&width=400",
          "product_url": "/products/woodnfinish_white-oak_l_tripletique",
          "product_id": 6982959267974,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-TPLQ-Matte.png?v=1776186154&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl_tripletique",
          "product_id": 6982959300742,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>White Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WOAK-PLTQM.png?v=1776256697&width=400",
          "product_url": "/products/woodnfinish_white-oak_s_polytique-it",
          "product_id": 6982959333510,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WOAK-PLTQ-Matte-WOAK.png?v=1776258919&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_polytique-it",
          "product_id": 6982959399046,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-PLTQ-Matte.png?v=1776263896&width=400",
          "product_url": "/products/woodnfinish_white-oak_l_polytique-it",
          "product_id": 6982959431814,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-PLTQ-Matte.png?v=1776279391&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl_polytique-it",
          "product_id": 6982959497350,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_jKdnbh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-POAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pickled Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK.png?v=1776107825&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s",
          "product_id": 6829867237510,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_098d1bf5-3165-42f4-8196-9af3722dc471.png?v=1776107846&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m",
          "product_id": 6829925728390,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK.png?v=1776107881&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l",
          "product_id": 6829915701382,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK.png?v=1776107907&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl",
          "product_id": 6829888864390,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_3M3Jjt-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-POAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pickled Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-TPLQS.png?v=1776177438&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s_tripletique",
          "product_id": 6829983072390,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-POAK-TPLQ-Satin-POAK.png?v=1776181629&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m_tripletique",
          "product_id": 6830030913670,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-TPLQ-Satin.png?v=1776184856&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l_tripletique",
          "product_id": 6830075871366,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-TPLQ-Matte.png?v=1776186200&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl_tripletique",
          "product_id": 6830108115078,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_3M3Jjt-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-POAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pickled Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-PLTQM.png?v=1776256808&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s_polytique-it",
          "product_id": 6830506213510,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-POAK-PLTQ-Matte-POAK.png?v=1776259053&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m_polytique-it",
          "product_id": 6830525284486,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-PLTQ-Matte.png?v=1776264009&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l_polytique-it",
          "product_id": 6830541144198,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-PLTQ-Matte.png?v=1776279590&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl_polytique-it",
          "product_id": 6830552842374,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_3M3Jjt-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-BARN"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Barn Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BARN.png?v=1776107950&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s",
          "product_id": 6829853016198,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_d105140b-f8c7-469b-a459-0ccb768ed624.png?v=1776108115&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m",
          "product_id": 6829831225478,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN.png?v=1776108136&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l",
          "product_id": 6829833781382,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN.png?v=1776108196&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl",
          "product_id": 6829845053574,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_qtKbhg-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-BARN-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Barn Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BARN-TPLQS.png?v=1776177524&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s_tripletique",
          "product_id": 6831222849670,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BARN-TPLQ-Satin-BARN.png?v=1776181709&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m_tripletique",
          "product_id": 6831726592134,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-TPLQ-Satin.png?v=1776185076&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l_tripletique",
          "product_id": 6831220326534,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-TPLQ-Matte.png?v=1776195148&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl_tripletique",
          "product_id": 6831218262150,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_qtKbhg-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-BARN-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Barn Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BARN-PLTQM.png?v=1776256940&width=400",
          "product_url": "/products/woodnfinish_barn-wood_s_polytique-it",
          "product_id": 6830476165254,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BARN-PLTQ-Matte-BARN.png?v=1776259196&width=400",
          "product_url": "/products/woodnfinish_barn-wood_m_polytique-it",
          "product_id": 6830480851078,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-PLTQ-Matte.png?v=1776264142&width=400",
          "product_url": "/products/woodnfinish_barn-wood_l_polytique-it",
          "product_id": 6830481965190,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-PLTQ-Matte.png?v=1776279756&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl_polytique-it",
          "product_id": 6830482784390,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_qtKbhg-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-DOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Dark Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK.png?v=1776108277&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s",
          "product_id": 6829859405958,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_db726b4c-c983-4960-b8bd-4c6273f7f0f7.png?v=1776108306&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m",
          "product_id": 6829921468550,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK.png?v=1776108327&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l",
          "product_id": 6829907312774,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK.png?v=1776108360&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl",
          "product_id": 6829877887110,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_ffNUDd-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-DOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Dark Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-TPLQS.png?v=1776177617&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s_tripletique",
          "product_id": 6829972324486,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DOAK-TPLQ-Satin-DOAK.png?v=1776181776&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m_tripletique",
          "product_id": 6830019903622,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-TPLQ-Satin.png?v=1776185130&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l_tripletique",
          "product_id": 6830071840902,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-TPLQ-Matte.png?v=1776186379&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl_tripletique",
          "product_id": 6830102085766,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_ffNUDd-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-DOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Dark Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-PLTQM.png?v=1776282446&width=400",
          "product_url": "/products/woodnfinish_dark-oak_s_polytique-it",
          "product_id": 6830496776326,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DOAK-PLTQ-Matte-DOAK.png?v=1776282548&width=400",
          "product_url": "/products/woodnfinish_dark-oak_m_polytique-it",
          "product_id": 6830520402054,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-PLTQ-Matte.png?v=1776264287&width=400",
          "product_url": "/products/woodnfinish_dark-oak_l_polytique-it",
          "product_id": 6830537638022,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-PLTQ-Matte.png?v=1776282611&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl_polytique-it",
          "product_id": 6830549762182,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_ffNUDd-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-BWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Black Walnut Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL.png?v=1776108444&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s",
          "product_id": 6829857800326,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_b974aa28-e25b-49e1-980d-b47b319d76a1.png?v=1776108458&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m",
          "product_id": 6829859078278,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL.png?v=1776108482&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l",
          "product_id": 6829863370886,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL.png?v=1776108502&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl",
          "product_id": 6830627881094,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_8PVhFr-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-BWAL-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Black Walnut Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL-TPLQS.png?v=1776177675&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s_tripletique",
          "product_id": 6829958529158,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BWAL-TPLQ-Satin-BWAL.png?v=1776181857&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m_tripletique",
          "product_id": 6829999358086,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-TPLQ-Satin.png?v=1776185182&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l_tripletique",
          "product_id": 6830045069446,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-TPLQ-Matte.png?v=1776186460&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl_tripletique",
          "product_id": 6830085963910,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_8PVhFr-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-BWAL-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Black Walnut Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-BWAL-PLTQM.png?v=1776257080&width=400",
          "product_url": "/products/woodnfinish_black-walnut_s_polytique-it",
          "product_id": 6830490452102,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BWAL-PLTQM-wBox.png?v=1777568506&width=400",
          "product_url": "/products/woodnfinish_black-walnut_m_polytique-it",
          "product_id": 6830490452102,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-PLTQ-Matte.png?v=1776264367&width=400",
          "product_url": "/products/woodnfinish_black-walnut_l_polytique-it",
          "product_id": 6830530330758,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-PLTQ-Matte.png?v=1776282853&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl_polytique-it",
          "product_id": 6830544126086,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_8PVhFr-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-WWSH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>White Wash Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WWSH_b9e327be-b88d-4ab9-8da4-f411abc42ea6.png?v=1776108613&width=400",
          "product_url": "/products/woodnfinish_white-wash_s",
          "product_id": 6829875888262,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_306859d5-8003-4a83-adc9-fb7a51aa0ea2.png?v=1776108627&width=400",
          "product_url": "/products/woodnfinish_white-wash_m",
          "product_id": 6829928480902,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH.png?v=1776108659&width=400",
          "product_url": "/products/woodnfinish_white-wash_l",
          "product_id": 6829918486662,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WWSH.png?v=1776108687&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl",
          "product_id": 6829902954630,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_tJctTj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WWSH-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>White Wash Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WWSH-TPLQS.png?v=1776177755&width=400",
          "product_url": "/products/woodnfinish_white-wash_s_tripletique",
          "product_id": 6829988774022,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WWSH-TPLQ-Satin-WWSH.png?v=1776182297&width=400",
          "product_url": "/products/woodnfinish_white-wash_m_tripletique",
          "product_id": 6830036779142,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-TPLQ-Matte-table_75dadad4-d67d-412b-9ae5-73f1b64fa4fd.png?v=1776276085&width=400",
          "product_url": "/products/woodnfinish_white-wash_l_tripletique",
          "product_id": 6830077542534,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WWSH-TPLQ-Satin.png?v=1776186545&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl_tripletique",
          "product_id": 6830114242694,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_tJctTj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WWSH-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH-PLTQ"
  },
  "rows": [
    {
      "heading": "<h3>White Wash Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WWSH-PLTQM.png?v=1776257220&width=400",
          "product_url": "/products/woodnfinish_white-wash_s_polytique-it",
          "product_id": 6830511718534,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WWSH-PLTQ-Matte-WWSH.png?v=1776259785&width=400",
          "product_url": "/products/woodnfinish_white-wash_m_polytique-it",
          "product_id": 6830528069766,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-PLTQ-Matte.png?v=1776264489&width=400",
          "product_url": "/products/woodnfinish_white-wash_l_polytique-it",
          "product_id": 6830542749830,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WWSH-PLTQ-Matte.png?v=1776267791&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl_polytique-it",
          "product_id": 6830555037830,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_tJctTj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-FOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>French Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK_c296f5bb-96fe-4e1a-a985-e91ad76a7d70.png?v=1776108788&width=400",
          "product_url": "/products/woodnfinish_french-oak_s",
          "product_id": 6829861601414,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_bbe8a71f-ce5d-423c-8a11-0e7def78072d.png?v=1776108804&width=400",
          "product_url": "/products/woodnfinish_french-oak_m",
          "product_id": 6829922680966,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK.png?v=1776108829&width=400",
          "product_url": "/products/woodnfinish_french-oak_l",
          "product_id": 6829910294662,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK.png?v=1776108853&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl",
          "product_id": 6829881098374,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_kjE7TJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-FOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>French Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK-TPLQS.png?v=1776177883&width=400",
          "product_url": "/products/woodnfinish_french-oak_s_tripletique",
          "product_id": 6829964230790,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-TPLQ-Satin-FOAK.png?v=1776182368&width=400",
          "product_url": "/products/woodnfinish_french-oak_m_tripletique",
          "product_id": 6830013022342,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-TPLQ-Satin.png?v=1776185301&width=400",
          "product_url": "/products/woodnfinish_french-oak_l_tripletique",
          "product_id": 6830070071430,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-TPLQ-Matte.png?v=1776187681&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl_tripletique",
          "product_id": 6830096121990,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_kjE7TJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-FOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>French Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-FOAK-PLTQM.png?v=1776257341&width=400",
          "product_url": "/products/woodnfinish_french-oak_s_polytique-it",
          "product_id": 6830494974086,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-PLTQ-Matte-FOAK.png?v=1776260201&width=400",
          "product_url": "/products/woodnfinish_french-oak_m_polytique-it",
          "product_id": 6830518632582,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-PLTQ-Matte.png?v=1776264581&width=400",
          "product_url": "/products/woodnfinish_french-oak_l_polytique-it",
          "product_id": 6830534557830,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-PLTQ-Matte.png?v=1776267860&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl_polytique-it",
          "product_id": 6830547959942,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_kjE7TJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-DRIW"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Drift Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DRIW.png?v=1776108924&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s",
          "product_id": 6829860487302,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_a73678a0-16bc-40ec-889d-806d6cedf8e2.png?v=1776108939&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m",
          "product_id": 6829921894534,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW.png?v=1776108958&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l",
          "product_id": 6829907837062,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW.png?v=1776108976&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl",
          "product_id": 6829879656582,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_nRBze3-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-DRIW-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Drift Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DRIW-TPLQS.png?v=1776195857&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s_tripletique",
          "product_id": 6829970030726,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DRIW-TPLQ-Satin-DRIW.png?v=1776182499&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m_tripletique",
          "product_id": 6830016823430,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-TPLQ-Satin.png?v=1776195995&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l_tripletique",
          "product_id": 6830071414918,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW-TPLQ-Matte.png?v=1776196080&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl_tripletique",
          "product_id": 6830101561478,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_nRBze3-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-DRIW-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Drift Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DRIW-PLTQM.png?v=1776257433&width=400",
          "product_url": "/products/woodnfinish_drift-wood_s_polytique-it",
          "product_id": 6830495268998,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DRIW-PLTQ-Matte-DRIW.png?v=1776260329&width=400",
          "product_url": "/products/woodnfinish_drift-wood_m_polytique-it",
          "product_id": 6830520107142,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-PLTQ-Matte.png?v=1776283598&width=400",
          "product_url": "/products/woodnfinish_drift-wood_l_polytique-it",
          "product_id": 6830536523910,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW-PLTQ-Matte.png?v=1776267918&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl_polytique-it",
          "product_id": 6830548516998,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_nRBze3-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-WETH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Weathered Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WETH_15da1b31-ff13-4a8a-81ad-6b0d68637347.png?v=1776109035&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s",
          "product_id": 6829872611462,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_7eeabd66-d736-40ac-89ff-ade36af20faa.png?v=1776109049&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m",
          "product_id": 6829927334022,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH.png?v=1776109066&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l",
          "product_id": 6829917995142,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WETH.png?v=1776109096&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl",
          "product_id": 6829901185158,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_aW7jVE-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WETH-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Weathered Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WETH-TPLQS.png?v=1776196216&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s_tripletique",
          "product_id": 6829962756230,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WETH-TPLQ-Satin-WETH.png?v=1776182550&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m_tripletique",
          "product_id": 6830010499206,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-TPLQ-Satin.png?v=1776185510&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l_tripletique",
          "product_id": 6830068564102,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WETH-TPLQ-Matte.png?v=1776189011&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl_tripletique",
          "product_id": 6830093893766,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_aW7jVE-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-WETH-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Weathered Wood Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-WETH-PLTQM.png?v=1776257514&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_s_polytique-it",
          "product_id": 6830493958278,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WETH-PLTQ-Matte-WETH.png?v=1776260482&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_m_polytique-it",
          "product_id": 6830517584006,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-PLTQ-Matte.png?v=1776283810&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_l_polytique-it",
          "product_id": 6830534295686,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WETH-PLTQ-Matte.png?v=1776267986&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl_polytique-it",
          "product_id": 6830547894406,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_aW7jVE-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-CHAR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Charcoal Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHAR.png?v=1776109160&width=400",
          "product_url": "/products/woodnfinish_charcoal_s",
          "product_id": 6829855473798,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_16019328-af48-46e1-a095-8d39e1591362.png?v=1776109240&width=400",
          "product_url": "/products/woodnfinish_charcoal_m",
          "product_id": 6829918781574,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR.png?v=1776109259&width=400",
          "product_url": "/products/woodnfinish_charcoal_l",
          "product_id": 6829905772678,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR.png?v=1776109287&width=400",
          "product_url": "/products/woodnfinish_charcoal_xl",
          "product_id": 6829877526662,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_X68nYP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CHAR-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Charcoal Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHAR-TPLQS.png?v=1776178159&width=400",
          "product_url": "/products/woodnfinish_charcoal_s_tripletique",
          "product_id": 6829962068102,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CHAR-TPLQ-Satin-CHAR.png?v=1776182619&width=400",
          "product_url": "/products/woodnfinish_charcoal_m_tripletique",
          "product_id": 6830007582854,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-TPLQ-Satin.png?v=1776185600&width=400",
          "product_url": "/products/woodnfinish_charcoal_l_tripletique",
          "product_id": 6830050934918,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-TPLQ-Matte.png?v=1776189170&width=400",
          "product_url": "/products/woodnfinish_charcoal_xl_tripletique",
          "product_id": 6830090584198,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_X68nYP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CHAR-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Charcoal Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHAR-PLTQM.png?v=1776257631&width=400",
          "product_url": "/products/woodnfinish_charcoal_s_polytique-it",
          "product_id": 6830493630598,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CHAR-PLTQ-Matte-CHAR.png?v=1776260710&width=400",
          "product_url": "/products/woodnfinish_charcoal_m_polytique-it",
          "product_id": 6830516830342,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-PLTQ-Matte.png?v=1776284476&width=400",
          "product_url": "/products/woodnfinish_charcoal_l_polytique-it",
          "product_id": 6830533378182,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-PLTQ-Matte.png?v=1776268160&width=400",
          "product_url": "/products/woodnfinish_charcoal_xl_polytique-it",
          "product_id": 6830546452614,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_X68nYP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-VCHY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Vintage Cherry Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHRY.png?v=1776109338&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s",
          "product_id": 6829869531270,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_988ac650-e84a-4d18-b959-f033c70adf6d.png?v=1776109380&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m",
          "product_id": 6829926187142,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY.png?v=1776109423&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l",
          "product_id": 6829917307014,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY.png?v=1776109465&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl",
          "product_id": 6829892599942,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_3wcjDQ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-VCHY-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Vintage Cherry Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHRY-TPLQS.png?v=1776178225&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s_tripletique",
          "product_id": 6829974716550,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CHRY-TPLQ-Gloss-CHRY.png?v=1776182703&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m_tripletique",
          "product_id": 6830025441414,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-TPLQ-Satin.png?v=1776185676&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l_tripletique",
          "product_id": 6830074069126,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-TPLQ-Matte.png?v=1776189293&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl_tripletique",
          "product_id": 6830105231494,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_3wcjDQ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-VCHY-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Vintage Cherry Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CHRY-PLTQM.png?v=1776257835&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_s_polytique-it",
          "product_id": 6830503329926,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CHRY-PLTQ-Matte-CHRY_3386d8c2-35f2-4ba1-a956-e1f46779af1b.png?v=1776262985&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_m_polytique-it",
          "product_id": 6830523449478,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-PLTQ-Matte.png?v=1776284733&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_l_polytique-it",
          "product_id": 6830538883206,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-PLTQ-Matte_9d92f3de-6e2a-4ba2-9873-aa339b076d3c.png?v=1776268374&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl_polytique-it",
          "product_id": 6830551695494,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_3wcjDQ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-CBLK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Classic Black Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CBLK.png?v=1776109506&width=400",
          "product_url": "/products/woodnfinish_classic-black_s",
          "product_id": 6829857734790,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_a2a032fd-4b54-4e03-b0f0-ed4d81582736.png?v=1776109523&width=400",
          "product_url": "/products/woodnfinish_classic-black_m",
          "product_id": 6829920125062,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK_0252ff93-c088-4045-a348-8ec1c300d46b.png?v=1776109551&width=400",
          "product_url": "/products/woodnfinish_classic-black_l",
          "product_id": 6829906657414,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CBLK.png?v=1776109577&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl",
          "product_id": 6829876904070,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_dp6XJc-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CBLK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Classic Black Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CBLK-TPLQS.png?v=1776178286&width=400",
          "product_url": "/products/woodnfinish_classic-black_s_tripletique",
          "product_id": 6829960003718,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CBLK-TPLQ-Satin-CBLK.png?v=1776182825&width=400",
          "product_url": "/products/woodnfinish_classic-black_m_tripletique",
          "product_id": 6830004895878,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-TPLQ-Satin.png?v=1776185732&width=400",
          "product_url": "/products/woodnfinish_classic-black_l_tripletique",
          "product_id": 6830046478470,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CBLK-TPLQ-Matte.png?v=1776189348&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl_tripletique",
          "product_id": 6830088388742,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_dp6XJc-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CBLK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Classic Black Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CBLK-PLTQM.png?v=1776257963&width=400",
          "product_url": "/products/woodnfinish_classic-black_s_polytique-it",
          "product_id": 6830492254342,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CBLK-PLTQM.png?v=1776284999&width=400",
          "product_url": "/products/woodnfinish_classic-black_m_polytique-it",
          "product_id": 6830515060870,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-PLTQ-Matte.png?v=1776285137&width=400",
          "product_url": "/products/woodnfinish_classic-black_l_polytique-it",
          "product_id": 6830531510406,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_classic-black_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CBLK-PLTQ-Matte.png?v=1776268638&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl_polytique-it",
          "product_id": 6830545043590,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_dp6XJc-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-JAVA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Java Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA.png?v=1776109621&width=400",
          "product_url": "/products/woodnfinish_java_s",
          "product_id": 6829863305350,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_25ec4220-90a3-4c18-a718-2334ac07f18e.png?v=1776109645&width=400",
          "product_url": "/products/woodnfinish_java_m",
          "product_id": 6829923205254,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_java_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA.png?v=1776109662&width=400",
          "product_url": "/products/woodnfinish_java_l",
          "product_id": 6829910753414,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA.png?v=1776109687&width=400",
          "product_url": "/products/woodnfinish_java_xl",
          "product_id": 6829882310790,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_tQnnEF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-JAVA-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Java Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA-TPLQS.png?v=1776178358&width=400",
          "product_url": "/products/woodnfinish_java_s_tripletique",
          "product_id": 6829957218438,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-JAVA-TPLQ-Satin-JAVA.png?v=1776182892&width=400",
          "product_url": "/products/woodnfinish_java_m_tripletique",
          "product_id": 6829994213510,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-TPLQ-Satin.png?v=1776185797&width=400",
          "product_url": "/products/woodnfinish_java_l_tripletique",
          "product_id": 6830041923718,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA-TPLQ-Matte.png?v=1776189453&width=400",
          "product_url": "/products/woodnfinish_java_xl_tripletique",
          "product_id": 6830081343622,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_tQnnEF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-JAVA-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Java Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-JAVA-PLTQM.png?v=1776258235&width=400",
          "product_url": "/products/woodnfinish_java_s_polytique-it",
          "product_id": 6830489665670,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-JAVA-PLTQ-Matte-JAVA.png?v=1776263281&width=400",
          "product_url": "/products/woodnfinish_java_m_polytique-it",
          "product_id": 6830512832646,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_java_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-PLTQ-Matte.png?v=1776285412&width=400",
          "product_url": "/products/woodnfinish_java_l_polytique-it",
          "product_id": 6830529904774,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA-PLTQ-Matte.png?v=1776268735&width=400",
          "product_url": "/products/woodnfinish_java_xl_polytique-it",
          "product_id": 6830543306886,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_tQnnEF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-CEDR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Cedar Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CEDR.png?v=1776109921&width=400",
          "product_url": "/products/woodnfinish_cedar_s",
          "product_id": 6829869170822,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_65dbed94-2d12-450e-b86d-f522e5e59828.png?v=1776109951&width=400",
          "product_url": "/products/woodnfinish_cedar_m",
          "product_id": 6829865599110,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR.png?v=1776109973&width=400",
          "product_url": "/products/woodnfinish_cedar_l",
          "product_id": 6829866254470,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CEDR.png?v=1776110026&width=400",
          "product_url": "/products/woodnfinish_cedar_xl",
          "product_id": 6829867204742,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_kbTJma-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CEDR-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Cedar Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CEDR-TPLQS.png?v=1776178477&width=400",
          "product_url": "/products/woodnfinish_cedar_s_tripletique",
          "product_id": 6829976289414,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CEDR-TPLQ-Satin-CEDR.png?v=1776183004&width=400",
          "product_url": "/products/woodnfinish_cedar_m_tripletique",
          "product_id": 6830027636870,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR-TPLQ-Satin.png?v=1776185910&width=400",
          "product_url": "/products/woodnfinish_cedar_l_tripletique",
          "product_id": 6830074921094,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CEDR-TPLQ-Matte_7c56c510-bafd-446a-969f-ea1a4a5cf8ea.png?v=1776189674&width=400",
          "product_url": "/products/woodnfinish_cedar_xl_tripletique",
          "product_id": 6830107230342,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_cedar_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_kbTJma-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-CEDR-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Cedar Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-CEDR-PLTQM.png?v=1776258466&width=400",
          "product_url": "/products/woodnfinish_cedar_s_polytique-it",
          "product_id": 6830505296006,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CEDR-PLTQ-Matte-CEDR.png?v=1776263475&width=400",
          "product_url": "/products/woodnfinish_cedar_m_polytique-it",
          "product_id": 6830524563590,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR-PLTQ-Matte.png?v=1776285858&width=400",
          "product_url": "/products/woodnfinish_cedar_l_polytique-it",
          "product_id": 6830539899014,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CEDR-PLTQ-Matte.png?v=1776268813&width=400",
          "product_url": "/products/woodnfinish_cedar_xl_polytique-it",
          "product_id": 6830552580230,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_cedar_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_kbTJma-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-OOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Old Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-OOAK.png?v=1776110073&width=400",
          "product_url": "/products/woodnfinish_old-oak_s",
          "product_id": 6829865730182,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_bcdf12cc-5884-46ec-8d55-b889f104eb8c.png?v=1776110087&width=400",
          "product_url": "/products/woodnfinish_old-oak_m",
          "product_id": 6829925073030,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK.png?v=1776110115&width=400",
          "product_url": "/products/woodnfinish_old-oak_l",
          "product_id": 6829913014406,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-OOAK.png?v=1776110154&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl",
          "product_id": 6829885161606,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_CjDzRP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-OOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK08-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Old Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-OOAK-TPLQS.png?v=1776178541&width=400",
          "product_url": "/products/woodnfinish_old-oak_s_tripletique",
          "product_id": 6829986054278,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-OOAK-TPLQ-Satin-OOAK.png?v=1776183046&width=400",
          "product_url": "/products/woodnfinish_old-oak_m_tripletique",
          "product_id": 6830034878598,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-TPLQ-Satin.png?v=1776185967&width=400",
          "product_url": "/products/woodnfinish_old-oak_l_tripletique",
          "product_id": 6830076657798,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-OOAK-TPLQ-Satin.png?v=1776189765&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl_tripletique",
          "product_id": 6830112768134,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_CjDzRP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-OOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Old Oak Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-OOAK-PLTQM.png?v=1776258551&width=400",
          "product_url": "/products/woodnfinish_old-oak_s_polytique-it",
          "product_id": 6830511292550,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-OOAK-PLTQ-Matte-OOAK.png?v=1776263564&width=400",
          "product_url": "/products/woodnfinish_old-oak_m_polytique-it",
          "product_id": 6830526759046,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-PLTQ-Matte.png?v=1776286046&width=400",
          "product_url": "/products/woodnfinish_old-oak_l_polytique-it",
          "product_id": 6830542422150,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_old-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-OOAK-PLTQ-Matte.png?v=1776268881&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl_polytique-it",
          "product_id": 6830554054790,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_CjDzRP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-PECA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pecan Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-PECA.png?v=1776110204&width=400",
          "product_url": "/products/woodnfinish_pecan_s",
          "product_id": 6829866025094,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_550fa8e0-a56f-4df2-ad4d-00d4b6f995b3.png?v=1776110220&width=400",
          "product_url": "/products/woodnfinish_pecan_m",
          "product_id": 6829925531782,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA.png?v=1776110236&width=400",
          "product_url": "/products/woodnfinish_pecan_l",
          "product_id": 6829914292358,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-PECA.png?v=1776110298&width=400",
          "product_url": "/products/woodnfinish_pecan_xl",
          "product_id": 6829885980806,
          "product_variant_id": null,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_pecan_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426114694__mg_product_swatches_Dkm4mq-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-PECA-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pecan Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-PECA-TPLQS.png?v=1776178821&width=400",
          "product_url": "/products/woodnfinish_pecan_s_tripletique",
          "product_id": 6829985497222,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-PECA-TPLQ-Satin-PECA.png?v=1776183113&width=400",
          "product_url": "/products/woodnfinish_pecan_m_tripletique",
          "product_id": 6830032715910,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA-TPLQ-Satin.png?v=1776186030&width=400",
          "product_url": "/products/woodnfinish_pecan_l_tripletique",
          "product_id": 6830076330118,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-PECA-TPLQ-Matte.png?v=1776189865&width=400",
          "product_url": "/products/woodnfinish_pecan_xl_tripletique",
          "product_id": 6830109819014,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18541426147462__mg_product_swatches_Dkm4mq-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-TPLQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-PECA-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Pecan Size Options</h3>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-PECA-PLTQM.png?v=1776258670&width=400",
          "product_url": "/products/woodnfinish_pecan_s_polytique-it",
          "product_id": 6830507917446,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-PECA-PLTQ-Matte-PECA.png?v=1776263666&width=400",
          "product_url": "/products/woodnfinish_pecan_m_polytique-it",
          "product_id": 6830525579398,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA-PLTQ-Matte.png?v=1776286121&width=400",
          "product_url": "/products/woodnfinish_pecan_l_polytique-it",
          "product_id": 6830542258310,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-PECA-PLTQ-Matte.png?v=1776268945&width=400",
          "product_url": "/products/woodnfinish_pecan_xl_polytique-it",
          "product_id": 6830553366662,
          "product_variant_id": null,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pecan_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "",
      "custom_template_id": "mgps-custom-template--18549190393990__mg_product_swatches_Dkm4mq-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit – 25 square feet</li>\n    <li>Medium Kit – 50 square feet</li>\n    <li>Large Kit – 100 square feet</li>\n    <li>Extra Lg Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNK-PLTQ-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-HGRY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Harbor Gray Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-SBCH.png?v=1776107136&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_s",
          "product_id": 7195719008390,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D.png?v=1776107184&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_m",
          "product_id": 7195720417414,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH.png?v=1776107229&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_l",
          "product_id": 7195720024198,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH_0073eaa6-f39d-4cf9-bab2-482416377a98.png?v=1776107303&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl",
          "product_id": 7195719499910,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18561159266438__mg_product_swatches_xEwEi7-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Sm Kit – 25 square feet</li>\n    <li>Med Kit – 50 square feet</li>\n    <li>Lg Kit – 100 square feet</li>\n    <li>XL Kit – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_subtext": "<p>Select</p>",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNK-MWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Modern Walnut Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-3D.png?v=1777490940&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s",
          "product_id": 7590538805382,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-3D.png?v=1777491212&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m",
          "product_id": 7590538707078,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-3D.png?v=1777491492&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l",
          "product_id": 7590538739846,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-3D.png?v=1777491775&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl",
          "product_id": 7590538772614,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18561159266438__mg_product_swatches_AwWypi-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Sm Kit â€“ 25 square feet</li>\n    <li>Med Kit â€“ 50 square feet</li>\n    <li>Lg Kit â€“ 100 square feet</li>\n    <li>XL Kit â€“ 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-MWAL-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Modern Walnut Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-TPLQM.png?v=1777491019&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s_tripletique",
          "product_id": 7590539034758,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-TPLQM.png?v=1777491303&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m_tripletique",
          "product_id": 7590539067526,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-TPLQ-Matte.png?v=1777491561&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l_tripletique",
          "product_id": 7590539001990,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-TPLQ-Matte.png?v=1777491884&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl_tripletique",
          "product_id": 7590538969222,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18561159266438__mg_product_swatches_9ae9rE-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Sm Kit â€“ 25 square feet</li>\n    <li>Med Kit â€“ 50 square feet</li>\n    <li>Lg Kit â€“ 100 square feet</li>\n    <li>XL Kit â€“ 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNK-MWAL-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h3>Modern Walnut Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-MWAL-PLTQM.png?v=1777491113&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_s_polytique-it",
          "product_id": 7590538838150,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-MWAL-PLTQM.png?v=1777491413&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_m_polytique-it",
          "product_id": 7590538870918,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-PLTQ-Matte.png?v=1777491693&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_l_polytique-it",
          "product_id": 7590538903686,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Extra Lg Kit",
          "alt": "Extra Lg Kit",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-PLTQ-Matte.png?v=1777491963&width=400",
          "product_url": "/products/woodnfinish_modern-walnut_xl_polytique-it",
          "product_id": 7590538936454,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_modern-walnut_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18561159266438__mg_product_swatches_rqcbpQ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Sm Kit â€“ 25 square feet</li>\n    <li>Med Kit â€“ 50 square feet</li>\n    <li>Lg Kit â€“ 100 square feet</li>\n    <li>XL Kit â€“ 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["WNK-SecondSealerOption"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": []
};

window.MG_SWATCH_SETS["WNK16-WOAK-TPLQ-Opt"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h1>Interior Topcoat Options</h1>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Matte (Most Popular)",
          "alt": "Matte (Most Popular)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/TPLQ-Matte-WOAK-Table.png?v=1776271105&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646946438",
          "product_id": 6982959235206,
          "product_variant_id": 40477646946438,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646946438",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Satin",
          "alt": "Satin",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/TPLQ-Satin-WOAK-Table.png?v=1776271109&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646848134",
          "product_id": 6982959235206,
          "product_variant_id": 40477646848134,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646848134",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gloss",
          "alt": "Gloss",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/TPLQ-Gloss-WOAK-Table.png?v=1776271116&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646913670",
          "product_id": 6982959235206,
          "product_variant_id": 40477646913670,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_tripletique?variant=40477646913670",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["WNK16-WOAK-PLTQ-Opt"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "heading": "<h1>Exterior Topcoat Options</h1>",
      "subheading": "",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Matte (Most Popular)",
          "alt": "Matte (Most Popular)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PLTQ-Matte-WOAK-Table.png?v=1776258940&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647503494",
          "product_id": 6982959399046,
          "product_variant_id": 40477647503494,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647503494",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Satin",
          "alt": "Satin",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PLTQ-Satin-WOAK-Table.png?v=1776258946&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647405190",
          "product_id": 6982959399046,
          "product_variant_id": 40477647405190,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647405190",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gloss",
          "alt": "Gloss",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PLTQ-Gloss-WOAK-Table.png?v=1776258950&width=400",
          "product_url": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647470726",
          "product_id": 6982959399046,
          "product_variant_id": 40477647470726,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_m_polytique-it?variant=40477647470726",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};

window.MG_SWATCH_SETS["WNK-Topcoat-Options"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Interior Topcoat Options</h2>",
      "subheading": "",
      "block_type": "swatch_variant",
      "product_handle_contains": "_polytique-it",
      "find_product_handle_contains": "_tripletique",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": 0,
      "row_height_mobile": 0,
      "row_height_desktop": 0,
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": 100,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": 0,
      "swatches": [
        {
          "type": "current_product_variants_source",
          "use_product_page_product": false,
          "source_product_handle": "",
          "heading_source": "option_name",
          "variant_option_name": "Size",
          "product_handle_contains": "_polytique-it",
          "find_product_handle_contains": "_tripletique",
          "variant_title_mode": "option_value",
          "variant_title_prefix": "",
          "show_price": false
        }
      ]
    },
    {
      "heading": "<h2>Exterior Topcoat Options</h2>",
      "subheading": "",
      "block_type": "swatch_variant",
      "product_handle_contains": "_tripletique",
      "find_product_handle_contains": "_polytique-it",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": 0,
      "row_height_mobile": 0,
      "row_height_desktop": 0,
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": 100,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": 0,
      "swatches": [
        {
          "type": "current_product_variants_source",
          "use_product_page_product": false,
          "source_product_handle": "",
          "heading_source": "option_name",
          "variant_option_name": "Size",
          "product_handle_contains": "_tripletique",
          "find_product_handle_contains": "_polytique-it",
          "variant_title_mode": "option_value",
          "variant_title_prefix": "",
          "show_price": false
        }
      ]
    }
  ]
};

window.MG_SWATCH_SETS["WNK-Topcoat-Switch-Button"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "button_switch": true,
      "preset_button": true,
      "preset_button_style": "dropdown_box",
      "preset_button_width_percent": 100,
      "preset_button_heading_justify": "center",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "button_switch_rules": [
        {
          "if_handle_contains": "_polytique-it",
          "button_text": "<p>Interior Topcoat Options</p>",
          "button_subtext": "<p>Select</p>",
          "replace_with": "_tripletique"
        },
        {
          "if_handle_contains": "_tripletique",
          "button_text": "<p>Exterior Topcoat Options</p>",
          "button_subtext": "<p>Select</p>",
          "replace_with": "_polytique-it"
        },
        {
          "if_handle_contains": "",
          "button_text": "",
          "button_subtext": "",
          "replace_with": ""
        },
        {
          "if_handle_contains": "",
          "button_text": "",
          "button_subtext": "",
          "replace_with": ""
        },
        {
          "button_text": "",
          "button_subtext": "",
          "replace_with": ""
        }
      ]
    }
  ]
};



// ✅ OPTIONAL: paste these ONCE after adding/updating one or more sets (helps previews refresh):
document.dispatchEvent(new CustomEvent("media_gallery_sets_ready"));
document.dispatchEvent(new CustomEvent("vimeo_sets_ready"));
